<h2 mat-dialog-title>
  Save Field Mappings
</h2>

<div mat-dialog-content class="dialog-content">
  <p class="dialog-description">
    You are about to save field mappings for the following destination:
  </p>

  <div class="summary-card">
    <span class="label">Destination:  </span>
    <span class="value">{{ data.destination_code | titlecase }}</span>
    <span class="label">Mappings:  </span>
        <span class="value" *ngFor="let maps of data.mappings">{{ maps.title | titlecase }}</span>


  </div>

  <p class="dialog-warning">
    This will immediately affect future feed generations.
  </p>
</div>

<div mat-dialog-actions align="end">
  <button mat-button (click)="cancel()">Cancel</button>
  <button mat-raised-button color="primary" (click)="continue()">
    Save Mappings
  </button>
</div>
